import { Typography, useTheme } from '@mui/material';
import { TagChip } from 'components/ui';
import { TableContext } from 'pages/PatientsPage';
import { riskList } from 'pages/PatientsPage/PatientsFilter/Filters/RiskFilter';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

export const RiskFilterChip = () => {
  const { t } = useTranslation();
  const theme = useTheme()
  const { filters, setFilters } = useContext(TableContext);

  const selectedRisks = filters?.risk;

  function deleteFilter(risk) {
    const newRiskFilter = filters.risk.filter((item) => item !== risk);
    setFilters({
      ...filters,
      risk: newRiskFilter,
    });
  }

  return selectedRisks?.map((risk) => (
    <TagChip
      key={risk}
      tag={
        <>
          <Typography
            component="span"
            color={theme.palette.colors.black}
            fontSize={'0.875rem'}
            fontWeight={'500'}
          >
            {`${t('Risk')}: `}
          </Typography>
          <Typography
            component="span"
            color={theme.palette.colors.blue100}
            fontSize={'0.875rem'}
            fontWeight={'500'}
          >
            {t(riskList.find((riskEl) => riskEl.value === risk).label)}
          </Typography>
        </>
      }
      handleDelete={() => deleteFilter(risk)}
      isCanDelete
      iconColor={theme.palette.colors.blue100}
    />
  ));
};
